import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";

import tick from "assets/images/authenticate/Frame.svg";
import authenticationImage from "assets/images/authenticate/authenticate.svg";
import authenticationImageDark from "assets/images/authenticate/authenticateDark.svg";
// import qr from "assets/images/authenticate/qr.svg";
// import qrDark from "assets/images/authenticate/qrDark.svg";
import ms from "assets/images/authenticate/microsoft.svg";
import google from "assets/images/authenticate/google.svg";
import copy from "assets/images/authenticate/copy.svg";
import copyDark from "assets/images/authenticate/copyDark.svg";

import useTheme from "hooks/observer";

import "./authentication.scss";
import { signupContext } from "context/SignupContext";
import { QRCodeCanvas } from "qrcode.react";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";

const Authentication = ({ nextStep, skip, setStep, setMailData, setCanGoNext }) => {
  const isMobile = useScreenMobile({ size: 568 });
  const { qrData: contextQrData, setQrData } = useContext(signupContext);
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { isReset } = location?.state?.stateToPass ?? {};
  const [enable, setEnable] = useState(false);
  const [showQr, setShowQr] = useState(true);
  const [qrData, setLocalQrData] = useState(contextQrData || "");
  const [isLoading, setIsLoading] = useState(false);
  const [copyText, setCopyText] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (setCanGoNext) setCanGoNext(enable);
  }, [enable, setCanGoNext]);

  const theme = useTheme();
  const authenticateImg =
    theme === "light" ? authenticationImage : authenticationImageDark;
  const copyCode = theme === "light" ? copy : copyDark;

  // Function to extract secret from OTP Auth URL
  const extractSecret = (otpAuthUrl) => {
    if (!otpAuthUrl) return null;

    try {
      // Extract the query string portion after the "?" in the otpauth URL
      const queryStartIndex = otpAuthUrl.indexOf("?");
      if (queryStartIndex === -1) return null;

      const queryString = otpAuthUrl.slice(queryStartIndex + 1);
      const params = new URLSearchParams(queryString);

      // Extract the 'secret' parameter
      const secret = params.get("secret");
      return secret;
    } catch (error) {
      console.error("Failed to extract secret:", error);
      return null;
    }
  };


  // Generate QR code when component mounts or when enable is set to true
  useEffect(() => {
    if (enable) {
      generateQRCode();
    }
  }, [enable]);

  // Generate QR code using the API
  const generateQRCode = async () => {
    setIsLoading(true);
    try {
      const qrResponse = qrData;
      // Check if the response contains a QR code URL
      if (qrResponse) {
        // If the API returns an object with QR data
        if (typeof qrResponse === "object" && qrResponse.qr_url) {
          setLocalQrData(qrResponse.qr_url);
          setQrData(qrResponse.qr_url);
        } else if (typeof qrResponse === "string") {
          // If the API returns a string directly
          setLocalQrData(qrResponse);
          setQrData(qrResponse);
        }

        // Extract and set the secret code
        const extractedSecret = extractSecret(
          typeof qrResponse === "object" ? qrResponse.qr_url : qrResponse
        );
        if (extractedSecret) {
          setCopyText(extractedSecret);
        } else if (qrResponse.manual_code) {
          setCopyText(qrResponse.manual_code);
        }
      }
    } catch (error) {
      console.error("Failed to generate QR code:", error);
      // Fallback to context data if available
      if (contextQrData) {
        setLocalQrData(contextQrData);
        const secretValue = extractSecret(contextQrData);
        if (secretValue) setCopyText(secretValue);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Reset copied state after 3 seconds
  useEffect(() => {
    if (copied) {

      const timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [copied]);



  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(copyText);
  };

  const proceedHandler = () => {
    nextStep();
  };

  const skipHandler = () => {
    setStep(5);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!enable) {
        setEnable(true);
      } else {
        proceedHandler();
      }
    } else if (e.key === "Escape" & skip) {
      skipHandler();
    }
  };


  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [enable, copied]);



  return (
    <>
      <section className="authContainer">
        <div className="mainContainer">
          {!enable ? (
            <div className="modalcontainer">
              <div className="authenticationText">
                <h2 className="title">Enable Two Factor Authentication</h2>
                <p className="detail">
                  For your security, we require two-factor authentication (2FA)
                  when logging into your account.
                </p>
              </div>
              <div className="authenticationContent">
                <div className="text">
                  <p>
                    2FA via an authenticator app gives your the highest level of
                    security
                  </p>
                </div>
                <div className="content">
                  <div className="ruleSet">
                    <div className="rules">
                      <div className="ruleContainer">
                        <div className="tick">
                          <img src={tick} alt="tick" />
                        </div>
                        <p className="rule">
                          Generate a unique code every 30 seconds
                        </p>
                      </div>
                      <div className="ruleContainer">
                        <div className="tick">
                          <img src={tick} alt="tick" />
                        </div>
                        <p className="rule">
                          Up to 2X times more secure than SMS
                        </p>
                      </div>
                    </div>
                    <div className="image">
                      <img src={authenticateImg} alt="authenticate" />
                      {/* <QRCodeCanvas value={qrData} size={256} /> */}
                    </div>
                  </div>
                  <div className="button" onClick={() => setEnable(true)}>
                    <p className="btnText">Set up now</p>
                  </div>
                  {skip && (
                    <p className="skip" onClick={skipHandler}>
                      Skip
                    </p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="modalContainers">
              <div className="registerTitle">
                <p>Register Two Factor Authenticator</p>
              </div>
              <div className="qrResponse">
                <p className="text">
                  {showQr ? "Scan QR Code" : "Enter the code"}
                </p>
                {showQr ? (
                  <div className="qr">
                    {/* <img src={qrCode} alt="qr code" /> */}
                    {isLoading ? (
                      <div className="loading">
                        <p>Loading QR code...</p>
                      </div>
                    ) : (
                      <QRCodeCanvas value={qrData} size={isMobile ? 160 : 226} />
                    )}
                  </div>
                ) : (
                  <div className="code">
                    <div className="codeBox">
                      <p>{copyText}</p>
                    </div>
                    {!copied && (
                      <div className="copy" onClick={handleCopy}>
                        <span className="tooltip">
                          {copied ? "Copied" : "Copy"}
                        </span>
                        <img src={copyCode} alt="copy" />
                      </div>
                    )}
                    {copied && (
                      <div className="copied">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M4.66602 9.99967L8.83268 14.1663L17.166 5.83301"
                            stroke="#339A33"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="tooltip">
                          {copied ? "Copied" : "Copy"}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                <p className="switch" onClick={() => setShowQr((pre) => !pre)}>
                  {showQr ? "Enter Code Manually" : "Scan QR code"}
                </p>
              </div>
              <div className="steps">
                <div className="step">
                  <p>Step 1</p>
                  <div className="suggestion">
                    <div className="text">
                      <p>
                        Install the Google or Microsoft authenticator in your
                        mobile
                      </p>
                    </div>
                    <div className="authenticators">
                      <div className="box">
                        <img src={google} alt="logo" className="logo" />
                        <p className="type">Google authenticator</p>
                      </div>
                      <div className="box">
                        <img src={ms} alt="logo" className="logo" />
                        <p className="type">Microsoft authenticator</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="step step2">
                  <p>Step 2</p>
                  <div className="suggestion">
                    <div className="text">
                      <p>
                        Open the scanner in the authenticator application and
                        scan the QR shown above{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Button title="Proceed" type="violet" onClick={proceedHandler} />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Authentication;
